// Datos públicos del negocio (los mismos que salen en las facturas PDF)
export const NOMBRE_NEGOCIO = "Maderas El Paca";
export const NOMBRE_LEGAL = "Compraventa de Maderas El Paca";

// WhatsApp (Colombia, +57)
export const CELULAR = "3012222358";
export const CELULAR_VISIBLE = "301 222 2358";

export const DIRECCION = "Cra 5 No. 27-07, Barrio San Roque";
export const CIUDAD = "Moñitos, Córdoba";
export const ENLACE_MAPA = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${DIRECCION}, ${CIUDAD}, Colombia`)}`;
